import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginPage from './pages/loginPages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MastersPage from './pages/masterPages/MastersPage';
import UserMasterPage from './pages/masterPages/UserMasterPage';
import TransactionPage from './pages/TransactionPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import RolePermissionsPage from './pages/settings/RolePermissionsPage';
import CompanyMasterPage from './pages/masterPages/CompanyMasterPage';
import CategoryGroupMasterPage from './pages/masterPages/styles/CategoryGroupMasterPage';
import StoneAttributeMasterPage from './pages/masterPages/stoneAttribute/StoneAttributeMasterPage';
import UomMasterPage from './pages/masterPages/uom/UomMasterPage';
import MetalPurityMasterPage from './pages/masterPages/metalPurity/MetalPurityMasterPage';
import OrderTypeMasterPage from './pages/masterPages/orderType/OrderTypeMasterPage';
import MouldMasterPage from './pages/masterPages/mould/MouldMasterPage';
import DepartmentMasterPage from './pages/masterPages/department/DepartmentMasterPage';
import RouteMasterPage from './pages/masterPages/route/RouteMasterPage';

function AuthGuard({ children }) {
  const user = useSelector(state => state.login.user);
  const location = useLocation();

  // If not logged in, redirect to login for all except /login
  if (!user && location.pathname !== '/login') {
    return <Navigate to="/login" replace />;
  }
  // If logged in and on /login, redirect to dashboard
  if (user && location.pathname === '/login') {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

const AppRouter = () => (
  <AuthGuard>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/masters" element={<MastersPage />} />
      <Route path="/masters/user/*" element={<UserMasterPage />} />
      
      <Route path="/transaction" element={<TransactionPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/role-permissions" element={<RolePermissionsPage />} />
      <Route path="/masters/company/*" element={<CompanyMasterPage />} />
      <Route path="/masters/styles/*" element={<CategoryGroupMasterPage />} />
      <Route path="/masters/stone-attribute/*" element={<StoneAttributeMasterPage />} />
      <Route path="/masters/uom/*" element={<UomMasterPage />} />
      <Route path="/masters/metal-purity/*" element={<MetalPurityMasterPage />} />
              <Route path="/masters/order-type/*" element={<OrderTypeMasterPage />} />
        <Route path="/masters/mould/*" element={<MouldMasterPage />} />
      <Route path="/masters/department/*" element={<DepartmentMasterPage />} />
       <Route path="/masters/route/*" element={<RouteMasterPage />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </AuthGuard>
);

export default AppRouter; 